module.exports = __webpack_public_path__ + "static/media/24UHCHR5.5841406a.jpg";